import { apiPost, type ApiResponse } from "@/lib/api";
import type { RpsBrief, RpsHand } from "@/lib/types";

export interface RpsWriteInput {
  subject: string;
  hand: RpsHand;
  limit_cnt: number;
  limit_min: number;
  reward?: string;
  memo?: string;
}

// 참여 응답 data
// 마감 전: { pick, hand, join_cnt, left_cnt, closed:0 }
// 내가 마지막 자리를 채웠으면 closed:1 과 결과가 함께 온다.
export interface RpsPlayResult {
  pick?: number;
  hand?: string;
  join_cnt?: number;
  left_cnt?: number;
  closed?: number;
  host_hand?: string;
  host_hand_txt?: string;
  result?: string;
  result_txt?: string;
  win_cnt?: number;
  [key: string]: unknown;
}

// 등록 (등록자가 자기 손을 미리 고른다)
export function writeRps(input: RpsWriteInput): Promise<ApiResponse<RpsBrief>> {
  return apiPost<RpsBrief>("rps_write.php", { act: "write", ...input });
}

// 등록자 조기 마감 → 결과 즉시 공개
export function closeRps(no: number): Promise<ApiResponse<unknown>> {
  return apiPost<unknown>("rps_write.php", { act: "close", no });
}

// 등록자 삭제 (참여자가 있으면 서버가 거절)
export function deleteRps(no: number): Promise<ApiResponse<unknown>> {
  return apiPost<unknown>("rps_write.php", { act: "del", no });
}

// 참여 (1인 1회, 낸 손은 못 바꿈)
export function playRps(no: number, hand: RpsHand): Promise<ApiResponse<RpsPlayResult>> {
  return apiPost<RpsPlayResult>("rps_play.php", { no, hand });
}